import { useEffect } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import { ListarCobrancasController } from "../../../../../Controllers/Geral/InformacoesVenda/InformacoesVendaControllers";
import useAsyncCallback from "../../../../../hooks/useAsyncCallback";
import { ICobrancaVenda } from "../../../../../Interfaces/Geral/InformacoesVenda/InformacoesVendaInterfaces";
import SpinnerUAU from "../../../../Loding/SpinnerUAU";
import Table from "../../../../Table";

interface IInfoCobrancaProps {
    lstCobrancasIds: Array<number>;
}

export default function InfoCobranca(props: IInfoCobrancaProps) {
    const {
        execute: ListarCobrancas,
        value: lstCobranca,
        loading,
    } = useAsyncCallback(ListarCobrancasController);

    useEffect(() => {
        if (props.lstCobrancasIds && props.lstCobrancasIds.length > 0)
            ListarCobrancas(props.lstCobrancasIds.join());
    }, [props.lstCobrancasIds, ListarCobrancas]);
    return (
        <>
            {loading ? (
                <SpinnerUAU />
            ) : (
                <Table
                    columns={columns}
                    data={lstCobranca ?? []}
                    keyField="Codigo_stc"
                    loading={loading}
                    noDataIndication={() => (
                        <div className="text-muted text-center">
                            Venda não possui Cobrança
                        </div>
                    )}
                    hover
                />
            )}
        </>
    );
}

const columns: Array<ColumnDescription<ICobrancaVenda>> = [
    {
        dataField: "Desc_stc",
        text: "Cobranças",
        classes: "p-2",
    },
];
